import * as React from "react"

import { SvgIconProps } from "styleguide/components/Svg/SvgIcon/SvgIcon"

import { Svg } from "styleguide/components"

const IconBooks = ({
  title = "Books",
  viewBoxWidth = 64,
  viewBoxHeight = 64,
  ...otherProps
}: SvgIconProps) => (
  <Svg.Icon {...{ title, viewBoxHeight, viewBoxWidth, ...otherProps }}>
    <g fill="none" fillRule="evenodd">
      <circle fill="#F77769" cx="32" cy="32" r="32" />
      <path
        d="M29 20a2 2 0 012 2v20a2 2 0 01-2 2H18a2 2 0 01-2-2V22c0-1.1.9-2 2-2h11zm-11 2v20h11V22H18zm28-2a2 2 0 012 2v20a2 2 0 01-2 2H35a2 2 0 01-2-2V22c0-1.1.9-2 2-2h11zm-11 2v20h11V22H35zm3 9h3a1 1 0 010 2h-3a1 1 0 010-2zm0-4h5a1 1 0 010 2h-5a1 1 0 010-2zm-17 4h5a1 1 0 010 2h-5a1 1 0 010-2zm0-4h5a1 1 0 010 2h-5a1 1 0 110-2zm0 8h5a1 1 0 010 2h-5a1 1 0 010-2z"
        fill="#FFF"
      />
    </g>
  </Svg.Icon>
)

export default IconBooks
